// extracted by mini-css-extract-plugin
export default {"Home":"Home_Home__PqQng","HomeContent":"Home_HomeContent__TOPDF","HomeTitle":"Home_HomeTitle__rBMVx","HomeDesc":"Home_HomeDesc__P7tas","HomeBtn":"Home_HomeBtn__3Z-DT"};